import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ListItem } from "@mui/material";
import ListItemButton, { ListItemButtonProps } from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { SidebarItem } from "@/layouts/types";

interface LinkItemProps {
  item: SidebarItem;
  sx: ListItemButtonProps["sx"];
  level: number;
  handleSubNavClick(): void;
  hasKeyInExpandedItems: boolean;
}

export function LinkItem({ item, sx, level, handleSubNavClick, hasKeyInExpandedItems }: LinkItemProps) {
  const location = useLocation();
  const fontSize = level === 0 ? "0.82rem" : "0.8rem";

  const { label, secondaryLabel, identifier, link = null, subItems = [], secondaryAction } = item;

  const selected = location.pathname.includes(link as string);

  const button = (
    <ListItem secondaryAction={secondaryAction} sx={{ p: 0 }}>
      <ListItemButton id={identifier} onClick={() => !link && handleSubNavClick()} selected={selected} sx={sx}>
        <ListItemText
          primary={label}
          secondary={secondaryLabel}
          slotProps={{ primary: { fontSize, fontWeight: selected ? 600 : "normal" } }}
        />
        {subItems.length > 0 && (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            {hasKeyInExpandedItems ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </Stack>
        )}
      </ListItemButton>
    </ListItem>
  );

  const isCurrentPath = (link: string) =>
    location.pathname === link ? (
      <>{button}</>
    ) : (
      <RouterLink to={link} style={{ textDecoration: "none" }}>
        {button}
      </RouterLink>
    );

  return link ? isCurrentPath(link) : button;
}
